import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

/** Numbered step indicator matching the reviewed Accord/TIS onboarding
 * screens (1 Company -> 2 Branding -> 3 Portals -> 4 Review, each with a
 * title + short description, connected by a progress line). */
export default function StepIndicator({ steps, current }) {
  return (
    <div className="flex items-center" data-testid="step-indicator">
      {steps.map((step, i) => {
        const stepNum = i + 1;
        const done = stepNum < current;
        const active = stepNum === current;
        return (
          <div key={step.title} className="flex flex-1 items-center last:flex-none">
            <div className="flex flex-col items-center gap-1 text-center">
              <div
                className={cn(
                  "flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold",
                  done && "bg-primary text-primary-foreground",
                  active && "bg-primary text-primary-foreground ring-4 ring-primary/20",
                  !done && !active && "bg-muted text-muted-foreground",
                )}
                data-testid={`step-circle-${stepNum}`}
              >
                {done ? <Check className="h-4 w-4" /> : stepNum}
              </div>
              <div className="hidden sm:block">
                <p className={cn("text-xs font-semibold", active ? "text-foreground" : "text-muted-foreground")}>{step.title}</p>
                <p className="text-[11px] text-muted-foreground">{step.description}</p>
              </div>
            </div>
            {stepNum < steps.length && <div className={cn("mx-2 h-0.5 flex-1", done ? "bg-primary" : "bg-border")} />}
          </div>
        );
      })}
    </div>
  );
}
